

















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapState } from 'vuex';
import AppHeader from 'frontend/components/AppHeader.vue';
import LandingHeaderV2 from 'frontend/views/landing/LandingHeaderV2.vue';
import { User } from 'frontend/types';

@Component({
  components: {
    AppHeader,
    LandingHeaderV2,
  },
  computed: {
    ...mapState('globals', ['user']),
  },
})
export default class Header extends Vue {
  private user!: User;

  get isAuthenticated() {
    return this.user && this.user.is_authenticated;
  }

  get routeName() {
    return this.$route.name;
  }
}
